//Libraries
import axios from "axios";

export const postForm = async (user_id, body) => {
  user_id = "000000000000000000000000";

  console.log("body :", body);

  let res = await axios.post(`${process.env.AW_API_HOST}/forms/${user_id}`, body).catch((e) => {
    console.error("Error [formService.js][postForm] : ", e);

    return null;
  });

  if (res && (res.status !== 200 || !res.data)) return null;

  return res;
};
